import { Component } from '@angular/core';

@Component({
  selector: 'mprd-telephony-level-two-skeleton',
  templateUrl: './telephony-level-two-skeleton.component.html',
})
export class TelephonyLevelTwoSkeletonComponent {
  constructor() {}
}
